import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useSearchParams, Link } from "react-router-dom";
import { API } from "@/context/AuthContext";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }

    const poll = async () => {
      try {
        const r = await axios.get(`${API}/checkout/status/${sessionId}`, { withCredentials: true });
        setData(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        if (attempts.current < 10) {
          attempts.current += 1;
          setTimeout(poll, 2000);
        } else {
          setStatus("timeout");
        }
      } catch {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen pt-32 pb-20 hero-gradient" data-testid="checkout-success-page">
      <div className="max-w-2xl mx-auto px-6 md:px-10 text-center">
        {status === "paid" ? (
          <>
            <CheckCircle size={64} weight="duotone" className="text-saffron mx-auto" />
            <h1 className="font-display text-5xl md:text-6xl mt-6 tracking-tighter">Payment confirmed.</h1>
            <p className="text-muted mt-4 max-w-md mx-auto">Funds are in escrow. Our team will match your order with verified farmers within 2 hours.</p>
            <div className="mt-8 glass rounded-2xl p-7 text-left">
              <div className="flex justify-between text-sm"><span className="text-muted">Amount</span><span className="text-cream">${(data.amount_total/100).toFixed(2)} {data.currency?.toUpperCase()}</span></div>
              <div className="flex justify-between text-sm mt-2"><span className="text-muted">Status</span><span className="text-saffron">{data.payment_status}</span></div>
            </div>
            <Link to="/buyer" className="btn-primary inline-flex mt-8">View orders <ArrowRight size={14} /></Link>
          </>
        ) : status === "checking" ? (
          <>
            <div className="w-10 h-10 mx-auto border-2 border-saffron/30 border-t-saffron rounded-full animate-spin" />
            <h1 className="font-display text-4xl mt-6">Confirming payment...</h1>
            <p className="text-muted mt-2 text-sm">This takes a few seconds.</p>
          </>
        ) : (
          <>
            <h1 className="font-display text-4xl mt-6">Payment {status}</h1>
            <p className="text-muted mt-2">Please check your email or contact support.</p>
            <Link to="/buyer" className="btn-secondary inline-flex mt-6">Go to orders</Link>
          </>
        )}
      </div>
    </div>
  );
}
